import HaveQuestionsView from './components/views/HaveQuestionsView';
import React, { Component } from 'react';
import {
	FaqView,
	HeaderView,
	FooterView,
	ContactUsView,
} from './components/views';

class FaqPage extends Component {
	componentDidMount () {
		window.scrollTo(0, 0);
	}

	render () {
		return (
			<main>
				<HeaderView opaque={true} />
				<FaqView />
				<HaveQuestionsView />
				<ContactUsView />
				<FooterView />
			</main>
		);
	}
}

export default FaqPage;



// WEBPACK FOOTER //
// ./src/FaqPage.js